module.exports = __webpack_public_path__ + "static/media/loader_round_green.d4d95d59.gif";